import React from "react";
import { FormatValueDecimal } from "../../utils/Validate";
import Avatar from "../common/Avatar";

const QuotationWorklistRow = ({ item, navigateToQuotationGeneral, rowIndex = 0 }) => (
  <div
    className={`card mt-1 quote-project-row ${rowIndex % 2 === 0 ? "row-even" : "row-odd"}`}
    onClick={() => navigateToQuotationGeneral(item)}
  >
    <div className="card-body">
      <div className="quote-project-grid">
        <div className="project-cell">
          <Avatar preName={item?.projectName} />
          <div className="project-copy">
            <h4 title={item?.projectName}>{item?.projectName}</h4>
            <span>{item?.projectReference}</span>
          </div>
        </div>
        <div className="ref-cell" title={item?.projectReference}>
          {item?.projectReference}
        </div>
        <div className="distributor-cell" title={item?.distributorName}>{item?.distributorName}</div>
        <div className="country-cell" title={item?.countryName}>{item?.countryName}</div>
        <div className="amount-cell quoted-cell">{FormatValueDecimal(item?.quoteValue)}</div>
        <div className="amount-cell order-cell">{FormatValueDecimal(item?.orderValue || 0)}</div>
        <div className="open-cell">
          <i className="fas fa-chevron-right" title="Open quotations"></i>
        </div>
      </div>
    </div>
  </div>
);

export default React.memo(QuotationWorklistRow);
